export default "__VITE_ASSET__zcVNEl59__"